export default {
    props: {
        name: {
            default () {
                return 'jingjinjiCounty';
            }
        },
   
        
    }
}